module.exports = __webpack_public_path__ + "img/travelling-thali-brand_application.9a7bf7b8.jpg";